import * as commander from 'commander';
import { VHostWorker } from "./entities/VHost";
import container from "./inversify.config";
import TYPES from "./TYPES";
import { ConsoleUI } from "./utils/ConsoleUI";

commander
    .command("list")
    .description("List all the existing VHost")
    // .option("-p, --pretty", "print the output in a more readable format")
    .action((cmd, options) => {
        invoke("listVhost");
    });


commander
    .command("create")
    .description("Configure new VHost from a running instance for an already configured CloudProvider")
    .action((cmd, options) => {
        invoke("createVhost");
    });

commander
    .command("stop")
    .description("Stop a VHost.")
    .option('-n, --hostname <value>', 'vhost to stop. If not specify, return a list to choose from')
    .action((cmd, options) => {
        const ui = container.get<ConsoleUI>(TYPES.ConsoleUI);
        const worker = container.get<VHostWorker>(TYPES.VHostWorker);

        worker.stopVhost(cmd.hostname)
        .then(res => {
            ui.loaderSuccess("Done");
            ui.log(res);
        })
        .catch(err => {
            ui.loaderFail("Error");
            ui.log(err.message);
            process.exit(100);
        });
    });

commander
    .command("update")
    .description("Update an existing VHost using a json dotted notation")
    .option('-n, --hostname <value>', 'vhost hostname')
    .option('-c, --change <value>', 'The parameter to change in JSON dotted notation ,example: a.b.c="new value"')
    .action((cmd, options) => {

        const ui = container.get<ConsoleUI>(TYPES.ConsoleUI);
        const worker = container.get<VHostWorker>(TYPES.VHostWorker);

        if(!cmd.hostname) {
            return ui.loaderFail("error: option `-n, --hostname <value>' argument missing");
        }

        if(!cmd.change) {
            return ui.loaderFail("error: option `-c, --change <value>' argument missing");
        }

        worker.updateVhost(cmd.hostname, cmd.change)
        .then(res => {
            ui.loaderSuccess("Ok");
        })
        .catch(err => {
            ui.loaderFail("Error");
            ui.log(err.message);
        });

    });

commander
    .command("delete")
    .option('-n, --hostname <value>', 'vhost hostname')
    .option('-y, --yes', 'automatically confirm')
    .description("Deregister an existing VHost")
    .action(function(cmd, options)  {

        const ui = container.get<ConsoleUI>(TYPES.ConsoleUI);
        const worker = container.get<VHostWorker>(TYPES.VHostWorker);

        let func = worker.deleteVhost(cmd.hostname, cmd.yes);


        func.then(res => {
            ui.loaderSuccess("Ok");
        })
        .catch(err => {
            ui.loaderFail("Error");
            ui.log(err.message);
        });

    });


function invoke(method: string): void {
    const ui = container.get<ConsoleUI>(TYPES.ConsoleUI);

    ui.loaderStart("Starting....");
    const worker = container.get<VHostWorker>(TYPES.VHostWorker);

    worker[method]()
        .then(res => {
            ui.loaderSuccess("Done");
            ui.log(res);
        })
        .catch(err => {
            ui.loaderFail("Error");
            ui.log(err.message);
        });

}

commander.parse(process.argv);
if (!commander.args.length) commander.help();